export const CHECK_CUSTOMER_SPD_REQUEST = 'CHECK CUSTOMER SPD REQUEST';
export const CHECK_CUSTOMER_SPD_SUCCESS = 'CHECK CUSTOMER SPD SUCCESS';
export const CHECK_CUSTOMER_SPD_FAILURE = 'CHECK CUSTOMER SPD FAILURE';

export const UPDATE_CUSTOMER_SPD = 'UPDATE_CUSTOMER_SPD';
export const UPDATE_CUSTOMER_SPD_REQUEST = 'UPDATE_CUSTOMER_SPD_REQUEST';
export const UPDATE_CUSTOMER_SPD_SUCCESS = 'UPDATE_CUSTOMER_SPD_SUCCESS';
export const UPDATE_CUSTOMER_SPD_FAILURE = 'UPDATE_CUSTOMER_SPD_FAILURE';

export const CUSTOMER_SPD_REQUEST = 'CUSTOMER SPD REQUEST';
export const CUSTOMER_SPD_SUCCESS = 'CUSTOMER SPD SUCCESS';
export const CUSTOMER_SPD_FAILURE = 'CUSTOMER SPD FAILURE';
export const CLEAR_CUSTOMER_SPD_ERROR = 'CLEAR CUSTOMER SPD ERROR';

export const REMOVE_COBUYER_SPD = 'REMOVE_COBUYER_SPD';

export const CLICKED_SHOW_CUSTOMER_SPD = 'CLICKED SHOW CUSTOMER SPD DATA';
export const APPLY_CUSTOMER_CARD_SPD_CHANGES = 'APPLY CUSTOMER CARD SPD CHANGES';
export const APPLY_CUSTOMER_CARD_NON_SPD_CHANGES = 'APPLY CUSTOMER CARD NON-SPD CHANGES';
